import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby-link';

import Header from '../components/header';
import Footer from '../components/footer';
import '../assets/scss/main.scss';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="JP Electric"
      meta={[
        { name: 'description', content: 'JP Electric offers complete electric service for projects of all sizes including residential/commercial repairs, design, maintenance, remodeling, and installation' },
        { name: 'keywords', content: 'electrical contractor, repairs, maintenance, remodeling, installation' },
        { name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1,user-scalable=0' }
      ]}
    >
      <link rel="shortcut icon" href={withPrefix('/img/favicon.ico')} type="image/x-icon" />
      <link rel="apple-touch-icon" href={withPrefix('/img/apple-touch-icon.png')} />
      <link rel="apple-touch-icon" sizes="57x57" href={withPrefix('/img/apple-touch-icon-57x57.png')} />
      <link rel="apple-touch-icon" sizes="72x72" href={withPrefix('/img/apple-touch-icon-72x72.png')} />
      <link rel="apple-touch-icon" sizes="76x76" href={withPrefix('/img/apple-touch-icon-76x76.png')} />
      <link rel="apple-touch-icon" sizes="114x114" href={withPrefix('/img/apple-touch-icon-114x114.png')} />
      <link rel="apple-touch-icon" sizes="120x120" href={withPrefix('/img/apple-touch-icon-120x120.png')} />
      <link rel="apple-touch-icon" sizes="144x144" href={withPrefix('/img/apple-touch-icon-144x144.png')} />
      <link rel="apple-touch-icon" sizes="152x152" href={withPrefix('/img/apple-touch-icon-152x152.png')} />
      <link rel="apple-touch-icon" sizes="180x180" href={withPrefix('/img/apple-touch-icon-180x180.png')} />
      <link rel="stylesheet" href="https://use.typekit.net/yqp6nhk.css" />
    </Helmet>
    <Header />
    <div className="content tk-aktiv-grotesk">
      {children()}
    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js